import React from 'react';
import { PillarRating } from '../types/alignment';

interface RatingSliderProps {
  label: string;
  description?: string;
  value?: PillarRating;
  onChange: (value: PillarRating) => void;
}

export function RatingSlider({ label, description, value, onChange }: RatingSliderProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(Number(e.target.value) as PillarRating);
  };

  return (
    <div className="space-y-3 p-6 bg-white rounded-lg border border-gray-200 hover:border-teal-300 transition-colors">
      <div>
        <label className="block text-lg font-semibold text-gray-900 mb-1">
          {label}
        </label>
        {description && (
          <p className="text-sm text-gray-600">{description}</p>
        )}
      </div>

      <div className="space-y-2">
        <input
          type="range"
          min="1"
          max="5"
          step="1"
          value={value || 3}
          onChange={handleChange}
          className="w-full h-3 bg-gray-200 rounded-lg appearance-none cursor-pointer slider-thumb"
          style={{
            background: value
              ? `linear-gradient(to right, #0d9488 0%, #0d9488 ${((value - 1) / 4) * 100}%, #e5e7eb ${((value - 1) / 4) * 100}%, #e5e7eb 100%)`
              : undefined
          }}
        />

        <div className="flex justify-between text-xs text-gray-500 px-1">
          <span>1 - Not Certain</span>
          <span>2</span>
          <span>3</span>
          <span>4</span>
          <span>5 - Very Certain</span>
        </div>

        {value && (
          <div className="text-center">
            <span className="inline-block px-4 py-2 bg-teal-100 text-teal-800 font-semibold rounded-lg">
              {value} / 5
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
